var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96161 0.513141L0 7.4726V10H2.52811L9.484 3.04626C10.1768 2.41638 10.1482 1.17305 9.48972 0.513856C8.5953 -0.380564 7.40059 0.0748681 6.96232 0.513856L6.96161 0.513141ZM2.23212 9.28504H0.714964V7.7686L5.96137 2.52362L7.47852 4.04006L2.23212 9.28504ZM8.98352 2.53577L7.984 3.53529L6.46685 2.01886L7.46709 1.01934C7.87033 0.602512 8.58457 0.603942 8.98924 1.02506C9.39463 1.39612 9.39248 2.16399 8.98352 2.53577Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9f008540d0bd4d0b3bc255a028978a2e.svg";
export { ForwardRef as ReactComponent };